<template>
  <div class="">
    <div class="navbar-area nav-bg-2">
      <!-- Mobile Navbar -->
      <div class="mobile-responsive-nav">
        <div>
          <b-navbar toggleable="lg">
            <div class="row align-items-center">
              <div class="col-9">
                <b-navbar-brand><router-link to="/" class="brand-lockup">
                    <img src="@/assets/site/images/GMEmblem.webp" class="brand-emblem" alt="" />
                    <span class="brand-words">
                      <span class="brand-name">Gracia Maria</span>
                      <span class="brand-tagline">Academy of English</span>
                    </span>
                  </router-link>
                </b-navbar-brand>
              </div>
              <div class="col-3">
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              </div>
            </div>

            <b-collapse id="nav-collapse" is-nav class="text-center">
              <b-navbar-nav>
                <b-nav-item>
                  <router-link to="/" class="nav-link">Home</router-link>
                </b-nav-item>
                <b-nav-item-dropdown text=" Courses">
                  <b-dropdown-item href="#">
                    <router-link to="/ielts" class="nav-link">IELTS</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/oet" class="nav-link">OET</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/pte" class="nav-link">PTE</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/german" class="nav-link">GERMAN</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/spoken-english" class="nav-link">SPOKEN ENGLISH</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/interview-training" class="nav-link">INTERVIEW TRAINING</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/online-classes" class="nav-link">ONLINE CLASSES</router-link></b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/weekend-classes" class="nav-link">WEEKEND CLASSES</router-link></b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item>
                  <router-link to="/about" class="nav-link">About Us</router-link>
                </b-nav-item>
                <b-nav-item>
                  <router-link to="/contact" class="nav-link">Contact Us</router-link>
                </b-nav-item>
                <!-- href goes on b-nav-item itself: it renders its own anchor
                     (href="#" + preventDefault when empty), and a nested <a>
                     gets its navigation cancelled by that bubbled handler. -->
                <b-nav-item href="https://www.ieltswithgraciamaria.com/" target="_blank">IELTS Blog</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
      <!-- Mobile Navbar Ends here -->
      <VueScrollFixedNavbar>
        <div class="desktop-nav">
          <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
              <router-link class="navbar-brand brand-lockup" to="/">
                <img src="@/assets/site/images/GMEmblem.webp" class="brand-emblem" alt="" />
                <span class="brand-words">
                  <span class="brand-name">Gracia Maria</span>
                  <span class="brand-tagline">Academy of English</span>
                </span>
              </router-link>
              <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link">Home</router-link>
                  </li>
                  <li class="nav-item">
                    <a href="#" class="nav-link dropdown-toggle">
                      Courses
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <router-link to="/ielts" class="nav-link">IELTS</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/oet" class="nav-link">OET</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/pte" class="nav-link">PTE</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/german" class="nav-link">GERMAN</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/spoken-english" class="nav-link">SPOKEN ENGLISH</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/interview-training" class="nav-link">INTERVIEW TRAINING</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/online-classes" class="nav-link">ONLINE CLASSES</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/weekend-classes" class="nav-link">WEEKEND CLASSES</router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                    <router-link to="/about" class="nav-link">About Us</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/contact" class="nav-link">Contact</router-link>
                  </li>
                  <li class="nav-item">
                    <a href="https://www.ieltswithgraciamaria.com/" target="_blank" class="nav-link">IELTS Blog</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </VueScrollFixedNavbar>
    </div>
  </div>
</template>

<script>
import { VueScrollFixedNavbar } from "vue-scroll-fixed-navbar";
export default {
  name: "HomeBar",
  components: {
    VueScrollFixedNavbar
  }

};
</script>

<style scoped>
/* Scoped to .nav-link. Unqualified, this also matched the brand link — which
   carries router-link-active on the home page — and its display: block
   !important broke the logo lockup out of its flex row. */
.nav-link.router-link-active {
  color: rgba(10, 10, 10, 1) !important;
  /* border-bottom: 2px solid var(--primary); */
  display: block !important;
}

.no-active {
  color: var(--dark) !important;
  border-bottom: 2px solid transparent;
  display: block !important;
}
</style>
